"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCloseConfiguration = void 0;
const react_1 = __importDefault(require("react"));
exports.IconCloseConfiguration = react_1.default.memo(() => {
    return (react_1.default.createElement("svg", { "data-selector-id": "icon-close-configuration", width: "32px", height: "32px", viewBox: "0 0 32 32" },
        react_1.default.createElement("path", { d: "M16,1c8.3,0,15,6.7,15,15s-6.7,15-15,15S1,24.3,1,16S7.7,1,16,1 M16,0C7.2,0,0,7.2,0,16 s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0", fill: "currentColor" }),
        react_1.default.createElement("polygon", { points: "20.7,12.7 19.3,11.3 16,14.6 12.7,11.3 11.3,12.7 14.6,16 11.3,19.3 12.7,20.7 16,17.4 19.3,20.7 20.7,19.3 17.4,16", fill: "currentColor" })));
});
exports.IconCloseConfiguration.displayName = 'IconCloseConfiguration';
//# sourceMappingURL=IconCloseConfiguration.js.map